import React from 'react';
import styles from './ErrorFallback.module.css';
import errorSvg from '../../assets/illustrations/SomethingWentWrong.svg';



const ErrorFallback = ({ error }) => (
  <div className={styles.container}>
    <div className={styles.contentWrapper}>
      <div className={styles.imageWrapper}>
        <img src={errorSvg} alt="Error illustration" className={styles.responsiveImage} />
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.heading}>Something went wrong</div>
        <div className={styles.subheading}>
          An unexpected error has occurred.<br />
          Please reload the page or contact support if the problem persists.
        </div>
        {error && (
          <details className={styles.errorDetails}>
            <summary>Show error details</summary>
            <pre>{error.message}</pre>
          </details>
        )}
        <button className={styles.retryButton} onClick={() => window.location.reload()}>
          Reload Page
        </button>
      </div>
    </div>
  </div>
);

export default ErrorFallback;